// import playground from './modules/playground'
// import frame from './modules/frame'
// import d2Crud from './modules/d2-crud'
// import plugins from './modules/plugins'
// import charts from './modules/charts'
// import components from './modules/components'
// import element from './modules/element'
// import filters from './modules/filters'
// import business from './modules/business'

import layoutHeaderAside from '@/layouts/HeaderAside'
import commerce from './modules/commerce'
import settings from './modules/settings'
import contact from './modules/contact'
import transport from './modules/transport'
import demo from './modules/demoTool'
import register from './modules/register'
import certificate from './modules/certificate'
import index from './modules/indexPage'
import container from './modules/container'
import myMessage from './modules/myMessage'
import guide from './modules/guide'
import shipmentBusiness from "./modules/shipmentBusiness";
import shipGoodsApply from "./modules/shipGoodsApply";
import transportService from "@/router/modules/transportService";
import deliveryBusiness from './modules/deliveryBusiness'
import orders from "./modules/orders"
import { yfcx, czxx, bllc } from "./modules/dl"
/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    // redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: [
      // 首页 必须 name:index
      {
        path: '/',
        name: 'index',
        meta: {
          auth: true,
          title: '首页'
        },
        component: () => import('@/pages/Index/page.vue')
      },
      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: {
          beforeRouteEnter (to, from, next) {
            next(vm => vm.$router.replace(from.fullPath))
          },
          render: h => h()
        }
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: {
          beforeRouteEnter (to, from, next) {
            next(vm => vm.$router.replace(JSON.parse(from.params.route)))
          },
          render: h => h()
        }
      },
      //运输服务详情页面
      {
        path: 'transportDetil',
        name: 'transportDetil',
        meta: {
          auth: true
        },
        component: () => import('@/pages/transport/transportDetil.vue')
      },
      //公告，咨询，新闻详情
      {
        path: 'industryInfo',
        name: 'industryInfo',
        meta: {
          auth: true
        },
        component: () => import('@/pages/industryInfo.vue')
      },
      //公告，咨询，新闻详情
      {
        path: 'newsDetail',
        name: 'newsDetail',
        meta: {
          auth: true
        },
        component: () => import('@/pages/newsDetail.vue')
      },
      //测试页
      //       {
      //         path: 'test',
      //         name: 'test',
      //         meta: {
      //           auth: true
      //         },
      //         component: () => import('@/pages/test.vue')
      //       }
    ]
  },
  commerce,
  settings,
  contact,
  // transport,
  demo,
  register,
  certificate,
  index,
  container,
  myMessage,
  guide,
  shipmentBusiness,
  shipGoodsApply,
  deliveryBusiness,
  transportService,
  orders,
  yfcx, czxx, bllc

]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login')
  },
  //忘记密码
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () => import('@/pages/forgetPW/forgetPW.vue')
  },
]

/**
 * 错误页面
 */
const errorPage = [
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('@/pages/Error404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]
